import './dashboard_charts_view.js.coffee'

class Monitoring.Views.SurveyDashboardChartsView extends Monitoring.Views.DashboardChartsView
  template: JST['backbone/templates/monitoring/dashboard_survey_charts']

  initialize: (@options = {}) ->
    super(@options)

  render: ->
    survey_charts = SurveyDashboardChartsView.surveyCharts(@facets.cem_surveys)
    SurveyDashboardChartsView.addInheritedCharts(survey_charts)
    @$el.html(@template({
      totalCount: @totalCount
      uniqueUsersCount: @uniqueUsersCount
      sessionSharingData: @sessionSharingData
      surveyCharts: survey_charts
    }))
    @listenTo(Backbone, 'charts:closed:update', @updateChartList)
    @renderCustomChartCreator()
    @renderSessionSharing()
    @$el.find('#preview_container').html(@socialContentsPreview.render().el)
    @

  renderCustomChartCreator: ->
    @mappedDimensions = []

    @mappedDimensions.push({code: 'nps', name: I18n.t('monitoring.dashboard.charts.nps_score')})
    @mappedDimensions.push({code: 'tags', name: 'Tags'})

    @survey = _.first(@facets.cem_surveys)
    if @survey && @survey.items
      for code, values of @survey.items
        survey_item_filter = new Monitoring.Models.SurveyItemFilter(code, values)
        if survey_item_filter.shouldBeRendered()
          @mappedDimensions.push({code: 'cem_survey_' + code, name: values.name})

    @customChartCreator = new Monitoring.Views.Charts.CustomCreator([], [], @mappedDimensions, @taxonomiesCodes)
    @customChartCreator.bind('addChart', @addCustomChart)
    @customChartCreator.render()
    @$el.append(@customChartCreator.el)

  updateChartList: ->
    activeCharts = ( {class: chart.class, name: chart.name} for chart in @chartToHideInList())
    ul = @$el.find('#graph-list')
    ul.find('li').removeClass('hidden')

    for chart in activeCharts
      ul.find("[data-class=#{chart.class}][data-name='#{chart.name}']").closest('li').addClass('hidden')

    addChartButton = @$el.find('button.add-chart')
    addChartButton.toggleClass('disabled', @_allChartsHidden())

  _allChartsHidden: ->
    @$el.find('#graph-list').find('li').not('.hidden').length == 0

  addChart: (event) =>
    settings = {
      class: $(event.target).data('class')
      name: $(event.target).data('name')
      code: $(event.target).data('code')
      actual_name: $(event.target).data('actual-name')
    }
    @addCustomChart(settings)

  addCustomChart: (settings) =>
    chart = @createChart(settings)
    @eventAggregator.trigger('monitoring:chart:add', chart.getGAName()) if chart?
    @$el.find('#chart-container').masonry('reloadItems')
    @chartsChange()

  @surveyCharts: (surveys) ->
    charts = []
    for survey in surveys
      for code, item of survey.items
        charts_list = SurveyDashboardChartsView._chartClass(item.type)
        for chart in charts_list
          if chart == 'NPSChartView' or chart ==  'NPSScoreChartView'
            name = I18n.t('monitoring.dashboard.charts.surveys.'+chart)
          else
            name = item.name
          charts.push {class: chart, name: name, code: code, actual_name: item.actual_name}

    charts

  @_chartClass: (type) ->
    switch type
      when 'Keepcon::Surveys::ScoreItem' then return ['ScoreItemChartView', 'CSATChartView']
      when 'Keepcon::Surveys::NPSItem' then return ['NPSChartView', 'NPSScoreChartView']
      else return ['ChoiceItemChartView']

  @addInheritedCharts: (charts) ->
    for survey in SurveyDashboardChartsView._monitorInheritedCharts()
      charts.push {class: survey.class, name: survey.name}
    charts

  @_monitorInheritedCharts: ->
    [
      {class: 'HistogramByTaxonomyView', name: I18n.t('monitoring.dashboard.charts.ugc_node_timeline')},
      {class: 'HierarchyNavigationBarsChartView', name: I18n.t('monitoring.dashboard.charts.h_navigation_bars')},
      {class: 'WordsCloudChartView', name: I18n.t('monitoring.dashboard.charts.topic_cloud')},
      {class: 'FilteredTagsPieChartView', name: I18n.t('monitoring.dashboard.charts.filtered_tags')},
      {class: 'HierarchyNavigationChartView', name: I18n.t('monitoring.dashboard.charts.h_navigation')},
      {class: 'FullHierarchyPieChartView', name: I18n.t('monitoring.dashboard.charts.h_tags')},
      {class: 'TagsPieChartView', name: I18n.t('monitoring.dashboard.charts.tags')},
      {class: 'TagsLevelZeroPieChartView', name: I18n.t('monitoring.dashboard.charts.tags_zero')},
      {class: 'TotalCountChartView', name: I18n.t('monitoring.dashboard.charts.total_count')},
      {class: 'TimeSlotHeatmapView', name: I18n.t('monitoring.dashboard.charts.time_slot_heat_map')},
      {class: 'SentimentPieChartView', name: I18n.t('monitoring.dashboard.charts.sentiment')}
    ]
